import Head from 'next/head'

import { useTranslation } from '@/components/useTranslation'
export default function AGB() {
    
    const t = useTranslation();
    return (
        <>
            <Head>
                <title>Taliqat123 | الشروط والأحكام</title>
            </Head>
            <div className='max-w-6xl py-32 mx-auto md:px-8 sub-page-content'>
                <div className="relative w-full ">
                    <div className="relative">
                        <div className="flex items-start justify-between p-4 border-b rounded-t">
                            <h1 className="text-3xl font-semibold text-gray-900"> الشروط والأحكام </h1>
                        </div>
                        <div className="p-6 space-y-6">
                            <div className="modal-inner">
                                <div className="py-3">
                                    <h6>{t.agb_title1}</h6>
                                    <p>{t.agb_description1}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.agb_title2}</h6>
                                    <p>{t.agb_description2}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.agb_title3}</h6>
                                    <p>{t.agb_description3}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.agb_title4}</h6>
                                    <p>{t.agb_description4}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.agb_title5}</h6>
                                    <p>{t.agb_description5}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.agb_title6}</h6>
                                    <p>{t.agb_description6}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.agb_title7}</h6>
                                    <p>{t.agb_description7}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.agb_title8}</h6>
                                    <p>{t.agb_description8}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.agb_title9}</h6>
                                    <p>{t.agb_description9}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.agb_title10}</h6>
                                    <p>{t.agb_description10}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.agb_title11}</h6>
                                    <p>{t.agb_description11}</p>
                                </div>
                                <div className="py-3">
                                    <h6>{t.agb_title12}</h6>
                                    <p>{t.agb_description12}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
